<script setup lang="ts">
import {computed, ref} from "vue";

interface Props {
    modelValue: string | number | null,
    label?: string,
    placeholder?: string,
    required?: boolean,
    errors?: string,
    type?: string,
    prependIcon?: string,
    hideDetails?: boolean
    hint?: string
    readonly?: boolean
    fieldClass?: string
}
const props = withDefaults(defineProps<Props>(), {
    required: false,
    type: 'text',
    hideDetails: false,
    readonly: false,
    fieldClass: undefined,
    hint: undefined,
    prependIcon: undefined,
    errors: undefined,
    label: undefined,
    placeholder: undefined,
})
const emit = defineEmits(['update:modelValue', 'focus', 'blur'])
const value = computed({
    get() {
        return props.modelValue
    },
    set(value) {
        emit('update:modelValue', value)
    }
})
const isActive = ref(false)
const bgColor = computed(() => {
    if (isActive.value) {
        return 'white'
    }
    return 'grey-lighten-4'
})

const toggleActive = (event: 'focus' | 'blur') => {
    emit(event)
    if (!props.readonly) {
        isActive.value = !isActive.value
    }
}
</script>

<template>
    <label
        v-if="label || $slots.label"
        class="black--text font-weight-bold text-body-2"
    >{{ label }} <slot name="label" /> <span
        v-if="required"
        class="text-error"
    >*</span></label>
    <v-text-field
        v-model="value"
        variant="outlined"
        class="mt-2"
        :class="fieldClass"
        :readonly="readonly"
        :placeholder="placeholder"
        :error-messages="errors"
        :hide-details="hideDetails"
        density="compact"
        rounded="lg"
        :type="type"
        color="blue"
        :bg-color="bgColor"
        :prepend-inner-icon="prependIcon"
        :hint="hint"
        @focus="toggleActive('focus')"
        @blur="toggleActive('blur')"
    >
        <template #append>
            <slot name="append" />
        </template>
    </v-text-field>
</template>

<style scoped>

</style>
